import App from '@/models/App'
import OrderingOrdererOrderItem from '@/models/OrderingOrdererOrderItem'

export default class OrderingReceiverEstimateItem extends App {
    static get entity() {
        return 'OrderingReceiverEstimateItems'
    }

    static all() {
        return this.query()
            .with('orderingOrderItem.orderingItem.orderingItemCategory')
            .get()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingEstimateId: this.attr(''),
            orderingOrderItemId: this.attr(''),
            unitPrice: this.attr(0),
            price: this.attr(0),
            isNotAcceptable: this.attr(false),
            reasonForNotAcceptable: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            orderingOrderItem: this.belongsTo(
                OrderingOrdererOrderItem,
                'orderingOrderItemId'
            ),
        }
    }

    static apiConfig = {
        actions: {},
    }
}
